import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './lightbox.module.scss'

class LightBox extends Component {
  constructor(props) {
    super(props)
    this.openLightBox = this.openLightBox.bind(this)
    this.state = {
      open: false,
    }
  }

  openLightBox() {
    this.setState({ open: !this.state.open })
  }

  render() {
    return (
      <div className={styles.thumbWrapper}>
        <div
          onClick={this.openLightBox}
          className={styles.thumb}
          style={{ backgroundImage: 'url(' + this.props.src + ')' }}
        ></div>
        {this.state.open ? (
          <div className={styles.background} onClick={this.openLightBox}>
            <div className={styles.content}>
              <img src={this.props.src} alt={this.props.alt} />
              <div className={styles.caption}>{this.props.alt}</div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

export default LightBox

LightBox.props = {
  src: PropTypes.string,
  alt: PropTypes.string,
}
